module.exports = __webpack_public_path__ + "static/img/pic-01.6a6cac4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/pic-01.jpg
// module id = /G4A
// module chunks = 1